import DigitalCollections from 'digital-collections-mfe'
import getMFEConfig from 'helpers/getMFEConfig'
import { WritableAtom, useAtomValue } from 'jotai'
import { jotaiStore } from 'store'
import { ModalState } from 'store/atoms/typings'
import { triggerAnalyticsEvent } from 'syf-js-utilities'
import { analyticsConfig } from 'syf-js-utilities/helpers/triggerAnalyticsEvent'
import { modalStatusAtom, selectedAccountAtom } from '../../store/atoms'

const DigitalCollectionsDrawer = () => {
  const selectedAccount = useAtomValue(selectedAccountAtom)
  const mfeConfig = getMFEConfig('mfe')

  return (
    <DigitalCollections
      triggerAnalyticsEvent={triggerAnalyticsEvent}
      analyticsConfig={analyticsConfig}
      config={mfeConfig}
      accountId={selectedAccount}
      atoms={{
        modalStatusAtom: modalStatusAtom as unknown as WritableAtom<
          ModalState,
          [
            modalId: string,
            modalTriggerId?: string,
            metadata?: Record<string, unknown>
          ],
          void
        >
      }}
      store={jotaiStore}
    />
  )
}

export default DigitalCollectionsDrawer
